import React, { useState, useEffect } from 'react';
import Spinner from '../components/Spinner';
import { useNavigate, useParams } from 'react-router-dom';
import { api } from '../services/api';
import { useNotification } from '../components/Notification';
import { getCurrencySymbol } from '../utils/currency';
import './Locations.css';
import './DetailPages.css';

function LocationDetail({ tenantId }) {
  const navigate = useNavigate();
  const { showNotification } = useNotification();
  const { id } = useParams();
  const [location, setLocation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tenant, setTenant] = useState(null);

  useEffect(() => {
    if (tenantId && id) {
      loadData();
    }
  }, [tenantId, id]);

  const loadData = async () => {
    try {
      setLoading(true);
      await Promise.all([
        loadTenant(),
        loadLocation()
      ]);
    } finally {
      setLoading(false);
    }
  };

  const loadTenant = async () => {
    try {
      const data = await api.get('/tenants', null);
      const currentTenant = data.find(t => t.id === tenantId) || data[0];
      setTenant(currentTenant);
    } catch (error) {
      console.error('Error loading tenant:', error);
    }
  };

  const currency = getCurrencySymbol(tenant?.taxSystem || 'DE');

  const loadLocation = async () => {
    try {
      const data = await api.get(`/locations/${id}`, tenantId);
      setLocation(data);
    } catch (error) {
      console.error('Error loading location:', error);
      showNotification('Fehler beim Laden des Werkstattorts', 'error');
      navigate('/locations');
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: currency === 'CHF' ? 'CHF' : 'EUR',
      minimumFractionDigits: 2
    }).format(amount);
  };

  if (loading) {
    return <Spinner />;
  }

  if (!location) {
    return <div>Werkstattort nicht gefunden</div>;
  }

  return (
    <div className="location-detail">
      <div className="detail-header">
        <button type="button" onClick={() => navigate('/locations')} className="btn-secondary">
          ← Zurück
        </button>
        <h1>{location.name}</h1>
        <button type="button" onClick={() => navigate(`/locations/${id}/edit`)} className="btn-primary">
          Bearbeiten
        </button>
      </div>

      {location.description && (
        <div className="detail-section">
          <h2>Beschreibung</h2>
          <p>{location.description}</p>
        </div>
      )}

      {location.address && (location.address.street || location.address.city) && (
        <div className="detail-section">
          <h2>Adresse</h2>
          <p>
            {location.address.street || ''}<br />
            {location.address.zip || ''} {location.address.city || ''}<br />
            {location.address.country || ''}
          </p>
        </div>
      )}

      <div className="detail-section">
        <h2>Miete</h2>
        <p><strong>Monatliche Miete:</strong> {location.monthlyRent ? formatCurrency(location.monthlyRent) : 'Nicht angegeben'}</p>
      </div>
    </div>
  );
}

export default LocationDetail;

